import React, { useState } from "react";
import { useRouteMatch, Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { GET_GRAPHIC_PACKING_LISTS_CURSOR } from 'graphql/query/graphic-packing-gql';
import GraphicPacking from 'components/graphic-packing';
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";
import { PageWrapDefault, Tables } from "components/layout";
import { Localize } from "components/service";
import { gqlBuilderWhere } from "utils";
const basePath = GraphicPacking.Const.basePath;
const tableHelper = GraphicPacking.Helpers.TableMain;


const GraphicPackingsPage = () => {
    useActiveMenuItem([ "graphic-packings" ], [ "graphic-packings" ]);

    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Graphic_Commissioning" }).props.children,
            path: `${ basePath }`
        }
    ]

    useBreadCrumbs(breadcrumbs);

    let match = useRouteMatch(`${ basePath }/page/:pageNum`);

    const [ searchText, setSearchText ] = useState("");
    const [ filters, setFilters ] = useState();

    const graphicPackingFilters = JSON.parse(localStorage.getItem("graphicPackingFilters"));

    return (
        <PageWrapDefault
            className="page-graphic-packing"
            dataExist={ true }
            title={ <Localize>PAGES.Title_GraphicCommissioning</Localize> }
        >
            <Tables.Cursor
                model="graphicListsCursor"
                query={ GET_GRAPHIC_PACKING_LISTS_CURSOR }
                varSet={ { first: 30 } }
                routeUrl={ `${ basePath }` }
                currentPage={ match ? parseInt(match.params.pageNum) : 1 }
                searchText={ searchText }
                objFilter={ filters || gqlBuilderWhere(graphicPackingFilters) }
                tableHelper={ tableHelper }
            >
                <div className="table-action-bar">
                    <div className="col">
                        <GraphicPacking.Filters.Table
                            setSearchText={ setSearchText }
                            setFilters={ setFilters }
                            filters={ filters }
                            graphicPackingFilters={ graphicPackingFilters }
                        />
                    </div>

                    <div className="col">
                        <Link
                            className="ant-btn ant-btn-primary"
                            to={ `${ basePath }/create` }
                        >
                            <PlusOutlined /> <Localize>GRAPHIC_PACKING.Button_Text_Create</Localize>
                        </Link>
                    </div>
                </div>
            </Tables.Cursor>
        </PageWrapDefault>
    );
};

export default GraphicPackingsPage;